module.exports = __webpack_public_path__ + "img/live.682e525b.png";